import { ComponentProps } from 'react';
import { Document, Page } from 'react-pdf';
import { MFlex } from '../chakra';
import MPageLoader from '../MPageLoader';

interface PdfDocumentProps {
  currentPdfFile: ArrayBuffer | Blob;
  onDocumentLoadSuccess: (pdf: any) => void;
  /**
   * Derived from `Page`'s props rather than deep-imported from
   * `react-pdf/dist/cjs/shared/types`: that path is not in the package's
   * `exports` map, so it does not resolve under `moduleResolution: "bundler"`.
   */
  textRenderer: NonNullable<ComponentProps<typeof Page>['customTextRenderer']>;
  /** Total pages reported by react-pdf. Nothing renders until this is a positive number. */
  numPages: number | null;
  /** Page scale; defaults to 1 (100%). */
  zoom?: number;
  /** Rendered page width in px. */
  size: number;
}

/**
 * Shared renderer for a multi-page PDF using react-pdf.
 * Consumers own data loading, sizing/resize, and text-highlighting logic.
 */
const PdfDocument = ({
  currentPdfFile,
  onDocumentLoadSuccess,
  textRenderer,
  zoom = 1,
  numPages,
  size,
}: PdfDocumentProps) => {
  return (
    <Document
      loading={
        <MFlex justify="center" grow={1}>
          <MPageLoader />
        </MFlex>
      }
      file={currentPdfFile}
      onLoadSuccess={onDocumentLoadSuccess}
    >
      {Array.from(new Array(numPages ?? 0), (el, index) => (
        <MFlex key={`page_${index + 1}`} p={1} justify="center">
          <Page
            customTextRenderer={textRenderer}
            pageNumber={index + 1}
            scale={zoom}
            className="pdf-page"
            width={size}
          />
        </MFlex>
      ))}
    </Document>
  );
};

export default PdfDocument;
